import { render, staticRenderFns } from "./InfiniteScrollObserver.vue?vue&type=template&id=a630d010"
import script from "./InfiniteScrollObserver.vue?vue&type=script&lang=js"
export * from "./InfiniteScrollObserver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports